import {Directive, ElementRef, EventEmitter, Host, HostListener, OnInit, Output, SkipSelf,} from '@angular/core';

@Directive({selector: '[resizable]', standalone: true})
export class ResizableDirective implements OnInit {
  _host: HTMLElement;
  _startWidth = 0;
  @Output() onResize: EventEmitter<number> = new EventEmitter();

  constructor(private elm: ElementRef) {
  }

  ngOnInit() {
    this._host = this.elm.nativeElement;
  }

  dragStart() {
    document.body.classList.add('inDragMode');

    const style = window.getComputedStyle(this._host, undefined);
    this._startWidth = style.width ? parseInt(style.width, 10) : 0;
  }

  dragging(diff: number) {
    this._host.style.width = this._startWidth + diff + 'px';
  }

  dragEnd() {
    document.body.classList.remove('inDragMode');

    this.onResize.emit(parseInt(this._host.style.width));
    this._startWidth = 0;
  }
}

@Directive({selector: '[grabber]', standalone: true})
export class GrabberDirective {

  @HostListener('mousedown', ['$event']) mousedown = (e: MouseEvent) => {
    this._startOffsetX = e.clientX;
    document.addEventListener('mousemove', this._boundDragging);
    document.addEventListener('mouseup', this._boundDragEnd);
    this.resizable.dragStart();
  };

  _startOffsetX = 0;
  readonly _boundDragging = (e: MouseEvent) => this._dragging(e);
  readonly _boundDragEnd = () => this._dragEnd();

  constructor(@Host() @SkipSelf() private resizable: ResizableDirective,
  ) {
  }

  private _dragging(e: MouseEvent) {
    const diff = e.clientX - this._startOffsetX;
    this.resizable.dragging(diff);
  }

  private _dragEnd() {
    this._startOffsetX = 0;
    document.removeEventListener('mousemove', this._boundDragging);
    document.removeEventListener('mouseup', this._boundDragEnd);
    this.resizable.dragEnd();
  }
}



